import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import MathInlineNode from './MathInlineNode';

export const MathInlineExtension = Node.create({
  name: 'mathInline',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      latex: {
        default: '',
      },
    };
  },
  
  addOptions() {
    return {
      onMathDoubleClick: (initialValue: string, onSave: (newValue: string) => void) => {},
    }
  },

  parseHTML() {
    return [
      {
        tag: 'math-inline',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['math-inline', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(MathInlineNode);
  },
});
